export type ContactStatus = 'NEW' | 'ASSIGNED' | 'IN_PROGRESS' | 'CLOSED';

export interface ContactRequest {
  id: string;
  colocId: string;
  name: string;
  email: string;
  phone: string | null;
  message: string | null;
  dateCreated: string;
  status: ContactStatus;
  assignedAgencyName: string | null;
  assignedAgencyUserId: string | null;
  assignedAt: string | null;
  ownerContextMessage: string | null;
  lastActionType: string | null;
  lastActionAt: string | null;
  // Chambre visée + qualification saisies sur le formulaire public.
  roomId: string | null;
  roomName: string | null;
  professionalStatus: string | null;
  moveInDate: string | null;
  stayDuration: string | null;
}

export const PROFESSIONAL_STATUS_LABELS: Record<string, string> = {
  ETUDIANT: 'Étudiant',
  SALARIE: 'Salarié',
  INDEPENDANT: 'Indépendant',
  FONCTIONNAIRE: 'Fonctionnaire',
  DEMANDEUR_EMPLOI: "En recherche d'emploi",
  RETRAITE: 'Retraité',
  AUTRE: 'Autre',
};

export const STAY_DURATION_LABELS: Record<string, string> = {
  MOINS_6_MOIS: 'Moins de 6 mois',
  '6_12_MOIS': '6 à 12 mois',
  '1_2_ANS': '1 à 2 ans',
  PLUS_2_ANS: 'Plus de 2 ans',
};

export interface ColocAgency {
  id: string;
  name: string;
  email: string;
  /** Accès gelé par le propriétaire. L'agence reste listée — la masquer la
   *  rendrait impossible à rétablir. */
  suspended?: boolean;
}

/** Une agence, vue transverse : toutes les colocations DU BAILLEUR qu'elle
 *  couvre, avec l'état de chacune. Le périmètre d'un autre bailleur sur la même
 *  agence n'y figure jamais. */
export interface AgencyOverview {
  id: string;
  name: string;
  email: string;
  colocs: { colocId: string; colocName: string; accessEnabled: boolean }[];
}

/** Réponse de l'octroi d'accès. `created: false` signale que le compte
 *  EXISTAIT déjà — une agence travaille souvent pour plusieurs bailleurs, et
 *  on ne crée jamais un second compte sur la même adresse. */
export interface AgencyGrantResult {
  id: string;
  name: string;
  email: string;
  created: boolean;
  invitationSent: boolean | null;
}

export const CONTACT_STATUS_LABELS: Record<ContactStatus, string> = {
  NEW: 'Nouveau',
  ASSIGNED: 'Assigné',
  IN_PROGRESS: 'En cours',
  CLOSED: 'Clôturé',
};

export interface ContactAction {
  id: string;
  actionType: string;
  actionLabel: string;
  note: string | null;
  createdAt: string;
  agencyName: string | null;
  agencyEmail: string | null;
}

export const CONTACT_ACTION_OPTIONS: { value: string; label: string }[] = [
  { value: 'CALLED', label: 'Appelé' },
  { value: 'EMAIL_SENT', label: 'Email envoyé' },
  { value: 'MEETING', label: 'RDV fixé' },
  { value: 'VISIT', label: 'Visite' },
  { value: 'NO_FOLLOWUP', label: 'Sans suite' },
];

export const CONTACT_ACTION_LABELS: Record<string, string> = Object.fromEntries(
  CONTACT_ACTION_OPTIONS.map((o) => [o.value, o.label])
);
